import { cleanCell, isPlaceholder } from '../data/transform'

export function formatCurrency(value: number): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
  }).format(value)
}

export function formatPercent(value: number): string {
  return new Intl.NumberFormat('en-US', {
    style: 'percent',
    maximumFractionDigits: 0,
  }).format(value)
}

export function displayValue(value: unknown, fallback = 'Not available'): string {
  return isPlaceholder(value) ? fallback : cleanCell(value)
}

export function formatLocation(city: string, state: string): string {
  const parts = [city, state].filter((value) => !isPlaceholder(value))
  return parts.length > 0 ? parts.join(', ') : 'Not provided'
}

export function formatDate(value: string): string {
  if (isPlaceholder(value)) return 'Not provided'
  const cleaned = cleanCell(value)
  const usDate = cleaned.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/)
  const date = usDate
    ? new Date(Date.UTC(Number(usDate[3]), Number(usDate[1]) - 1, Number(usDate[2])))
    : new Date(cleaned)
  if (Number.isNaN(date.getTime())) return cleanCell(value)
  return new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    timeZone: 'UTC',
  }).format(date)
}

export function firstUrl(value: string): string | null {
  if (isPlaceholder(value) || /does not have/i.test(value)) return null
  const match = value.match(/https?:\/\/[^\s#]+(?:#)?/i)
  if (match) return match[0].replace(/#$/, '')
  const cleaned = cleanCell(value)
  if (/^[\w.-]+\.[a-z]{2,}(?:\/.*)?$/i.test(cleaned)) return `https://${cleaned}`
  return null
}

export function compactUrl(value: string): string {
  const url = firstUrl(value)
  if (!url) return displayValue(value)
  return url.replace(/^https?:\/\/(www\.)?/i, '').replace(/\/$/, '')
}
